import { createSlice } from "@reduxjs/toolkit";
import {
  buscarRelatorioLancamentoFinanceiro,
  buscarRelatorioLancamentoFinanceiroDrill,
  buscarRelatorioLancamentoFinanceiroPorMes,
  buscarRelatorioLancamentoFinanceiroPorMesDrill,
  gerarRelatorioContaBancaria,
  gerarRelatorioContaFinanceira,
  gerarRelatorioCreditosConsignatario,
  gerarRelatorioLancamentoBancario,
  gerarRelatorioMovimentacaoBancaria,
  gerarRelatorioConsolidadoSaldoBancario,
  gerarRelatorioConsolidadoSaldoBancarioDetalhe,
  gerarRelatorioConsolidadoSaldoBancarioResumo,
} from "../../../services/relatorioService";
import { BuscaRelatorioModel } from "../../../models/relatorio/BuscaRelatorioModel";
import { RelatorioMovimentacaoBancariaVM } from "../../../models/relatorio/RelatorioMovimentacaoBancariaVM";
import { resetAll } from "../../actions/actions";
import { RelatorioLancamentoBancarioVM } from "../../../models/relatorio/RelatorioLancamentoBancarioVM";
import { RelatoriosContasFinanceiraVM } from "../../../models/relatorio/RelatorioContasFinanceiraVM";
import { RelatorioContaBancariaVM } from "../../../models/relatorio/RelatorioContaBancariaVM";
import { BuscaRelatorioContaBancariaModel } from "../../../models/relatorio/BuscaRelatorioContaBancariaModel";
import { BuscarRelatorioCreditosConsignatarioModel } from "../../../models/relatorio/buscarRelatorioCreditosConsignatarioModel";
import { CreditosConsignatariosModal } from "../../../models/relatorio/creditosConsignatariosModal";
import { RelatorioLancamentoFinanceiroModel } from "../../../models/relatorio/relatorioLancamentoFinanceiroModel";
import { BuscarRelatorioLancamentoFinanceiroModel } from "../../../models/relatorio/buscarRelatorioLancamentoFinanceiroModel";
import { RelatorioLancamentoFinanceiroDrillModel } from "../../../models/relatorio/relatorioLancamentoFinanceiroDrillModel";
import dayjs from "dayjs";
import { RelatorioLancamentoFinanceiroPorMesModel } from "../../../models/relatorio/relatorioLancamentoFinanceiroPorMesModel";
import { RelatorioConsolidadoSaldoBancarioModel } from "../../../models/relatorio/relatorioConsolidadoSaldoBancarioModel";
import { RelatorioConsolidadoSaldoBancarioDetalheModel } from "../../../models/relatorio/relatorioConsolidadoSaldoBancarioDetalheModel";
import { RelatorioConsolidadoSaldoBancarioResumoModel } from "../../../models/relatorio/relatorioConsolidadoSaldoBancarioResumoModel";
import { BuscarRelatorioConsolidadoSaldoBancarioModel } from "../../../models/relatorio/buscarRelatorioConsolidadoSaldoBancarioModel";

dayjs.locale("pt-br");

export interface RelatorioState {
  //gerar relatorio movimentacao bancaria
  loadingMovimentacaoBancaria: boolean;
  listMovimentacaoBancaria: RelatorioMovimentacaoBancariaVM[];
  //gerar relatorio lancamento bancario
  loadingLancamentoBancario: boolean;
  listLancamentoBancario: RelatorioLancamentoBancarioVM[];
  //gerar relatorio conta financeira
  loadingContaFinanceira: boolean;
  listContaFinanceira: RelatoriosContasFinanceiraVM[];
  //gerar relatorio conta bancaria
  loadingContaBancaria: boolean;
  buscaContaBancaria: BuscaRelatorioContaBancariaModel;
  listContaBancaria: RelatorioContaBancariaVM[];
  //gerar relatorio creditos consignatarios
  loadingCreditosConsignatario: boolean;
  buscaCreditosConsignatario: BuscarRelatorioCreditosConsignatarioModel;
  listCreditosConsignatario: CreditosConsignatariosModal[];
  //buscar relatorio lancamento financeiro
  loadingLancamentoFinanceiro: boolean;
  buscaLancamentoFinanceiro: BuscarRelatorioLancamentoFinanceiroModel;
  listLancamentoFinanceiro: RelatorioLancamentoFinanceiroModel[];
  //buscar relatorio lancamento financeiro drill
  loadingLancamentoFinanceiroDrill: boolean;
  listLancamentoFinanceiroDrill: RelatorioLancamentoFinanceiroDrillModel[];
  //buscar relatorio lancamento financeiro por mes
  listLancamentoFinanceiroPorMes: RelatorioLancamentoFinanceiroPorMesModel[];
  //gerar relatorio consolidado saldo bancario
  loadingConsolidadoSaldoBancario: boolean;
  buscaConsolidadoSaldoBancario: BuscarRelatorioConsolidadoSaldoBancarioModel;
  listConsolidadoSaldoBancario: RelatorioConsolidadoSaldoBancarioModel[];
  //gerar relatorio consolidado saldo bancario detalhe (contas individuais)
  loadingConsolidadoSaldoBancarioDetalhe: boolean;
  listConsolidadoSaldoBancarioDetalhe: RelatorioConsolidadoSaldoBancarioDetalheModel[];
  //gerar relatorio consolidado saldo bancario resumo (composicao de resultado)
  loadingConsolidadoSaldoBancarioResumo: boolean;
  listConsolidadoSaldoBancarioResumo: RelatorioConsolidadoSaldoBancarioResumoModel[];
  //internal
  error: string | undefined | null;
  relatorioPDF: BuscaRelatorioModel;
  modalLancamentoFinanceiro: boolean;
}

const initialState: RelatorioState = {
  //gerar relatorio movimentacao bancaria
  loadingMovimentacaoBancaria: false,
  listMovimentacaoBancaria: [],
  //gerar relatorio lancamento bancario
  loadingLancamentoBancario: false,
  listLancamentoBancario: [],
  //gerar relatorio conta financeira
  loadingContaFinanceira: false,
  listContaFinanceira: [],
  //gerar relatorio conta bancaria
  loadingContaBancaria: false,
  buscaContaBancaria: {
    tipoDataFiltro: "SORT",
    dataInicio: dayjs().startOf("month").startOf("day").toDate(),
    dataFim: dayjs().endOf("month").startOf("day").toDate(),
    idContaBanco: null,
    idEmpresa: null,
    realizado: true,
    naoRealizado: true,
    vencido: true,
    filtros: null,
  },
  listContaBancaria: [],
  //gerar relatorio creditos consignatarios
  loadingCreditosConsignatario: false,
  buscaCreditosConsignatario: {
    idEmpresa: 0,
    dataInicio: dayjs().startOf("month").startOf("day").toDate(),
    dataFim: dayjs().endOf("month").startOf("day").toDate(),
  } as BuscarRelatorioCreditosConsignatarioModel,
  listCreditosConsignatario: [],
  //buscar relatorio lancamento financeiro
  loadingLancamentoFinanceiro: false,
  buscaLancamentoFinanceiro: {
    tipoRelatorio: "planoConta",
    idEmpresa: 0,
    tipoDataFiltro: "SORT",
    dataInicio: dayjs().startOf("month").startOf("day").toDate(),
    dataFim: dayjs().endOf("month").startOf("day").toDate(),
    filtros: null,
    exibirTransferencias: true,
    somenteTransferencias: false,
  } as BuscarRelatorioLancamentoFinanceiroModel,
  listLancamentoFinanceiro: [],
  //buscar relatorio lancamento financeiro drill
  loadingLancamentoFinanceiroDrill: false,
  listLancamentoFinanceiroDrill: [],
  //buscar relatorio lancamento financeiro por mes
  listLancamentoFinanceiroPorMes: [],
  //gerar relatorio consolidado saldo bancario
  loadingConsolidadoSaldoBancario: false,
  buscaConsolidadoSaldoBancario: {
    tipoDataFiltro: "LANC",
    dataInicio: dayjs().startOf("month").startOf("day").toDate(),
    dataFim: dayjs().endOf("month").startOf("day").toDate(),
    listaEmpresa: [],
    realizado: true,
    naoRealizado: true,
    vencido: true,
    filtros: null,
  },
  listConsolidadoSaldoBancario: [],
  //gerar relatorio consolidado saldo bancario detalhe
  loadingConsolidadoSaldoBancarioDetalhe: false,
  listConsolidadoSaldoBancarioDetalhe: [],
  //gerar relatorio consolidado saldo bancario resumo
  loadingConsolidadoSaldoBancarioResumo: false,
  listConsolidadoSaldoBancarioResumo: [],
  //internal
  error: null,
  relatorioPDF: {} as BuscaRelatorioModel,
  modalLancamentoFinanceiro: false,
};

export const relatorioSlice = createSlice({
  name: "relatorio",
  initialState,
  reducers: {
    //gerar relatorio conta bancaria
    setBuscaRelatorioContaBancaria: (state, action) => {
      state.buscaContaBancaria = action.payload;
    },
    //gerar relatorio creditos consignatarios
    setBuscaRelatorioCreditosConsignatario: (state, action) => {
      state.buscaCreditosConsignatario = action.payload;
    },
    //buscar relatorio lancamento financeiro
    setBuscaRelatorioLancamentoFinanceiro: (state, action) => {
      state.buscaLancamentoFinanceiro = action.payload;
    },
    setRelatorioLancamentoFinanceiro: (state, action) => {
      state.listLancamentoFinanceiro = action.payload;
    },
    //internal
    setModalRelatorioLancamentoFinanceiro: (state, action) => {
      state.modalLancamentoFinanceiro = action.payload;
    },
    clearRelatorio: (state, action) => {
      state.relatorioPDF = action.payload;
      state.listContaFinanceira = [];
      state.listMovimentacaoBancaria = [];
      state.listLancamentoBancario = [];
      state.listContaBancaria = [];
    },
    resetRelatorioContaBancaria: (state) => {
      state.listContaBancaria = [];
    },
    //gerar relatorio consolidado saldo bancario
    setBuscaConsolidadoSaldoBancario: (state, action) => {
      state.buscaConsolidadoSaldoBancario = action.payload;
    },
    resetRelatorioConsolidadoSaldoBancario: (state) => {
      state.listConsolidadoSaldoBancario = [];
      state.listConsolidadoSaldoBancarioDetalhe = [];
      state.listConsolidadoSaldoBancarioResumo = [];
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //gerar relatorio movimentacao bancaria
    builder.addCase(gerarRelatorioMovimentacaoBancaria.pending, (state) => {
      state.loadingMovimentacaoBancaria = true;
    });
    builder.addCase(gerarRelatorioMovimentacaoBancaria.fulfilled, (state, action) => {
      state.listMovimentacaoBancaria = action.payload;
      state.loadingMovimentacaoBancaria = false;
    });
    builder.addCase(gerarRelatorioMovimentacaoBancaria.rejected, (state, action) => {
      state.loadingMovimentacaoBancaria = false;
    });

    //gerar relatorio lancamento bancario
    builder.addCase(gerarRelatorioLancamentoBancario.pending, (state) => {
      state.loadingLancamentoBancario = true;
    });
    builder.addCase(gerarRelatorioLancamentoBancario.fulfilled, (state, action) => {
      state.listLancamentoBancario = action.payload;
      state.loadingLancamentoBancario = false;
    });
    builder.addCase(gerarRelatorioLancamentoBancario.rejected, (state, action) => {
      state.loadingLancamentoBancario = false;
    });

    //gerar relatorio conta financeira
    builder.addCase(gerarRelatorioContaFinanceira.pending, (state) => {
      state.loadingContaFinanceira = true;
    });
    builder.addCase(gerarRelatorioContaFinanceira.fulfilled, (state, action) => {
      state.listContaFinanceira = action.payload;
      state.loadingContaFinanceira = false;
    });
    builder.addCase(gerarRelatorioContaFinanceira.rejected, (state, action) => {
      state.loadingContaFinanceira = false;
    });

    //gerar relatorio conta bancaria
    builder.addCase(gerarRelatorioContaBancaria.pending, (state) => {
      state.loadingContaBancaria = true;
    });
    builder.addCase(gerarRelatorioContaBancaria.fulfilled, (state, action) => {
      state.listContaBancaria = action.payload;
      state.loadingContaBancaria = false;
    });
    builder.addCase(gerarRelatorioContaBancaria.rejected, (state, action) => {
      state.loadingContaBancaria = false;
    });

    //gerar relatorio creditos consignatarios
    builder.addCase(gerarRelatorioCreditosConsignatario.pending, (state) => {
      state.loadingCreditosConsignatario = true;
    });
    builder.addCase(gerarRelatorioCreditosConsignatario.fulfilled, (state, action) => {
      state.listCreditosConsignatario = action.payload;
      state.loadingCreditosConsignatario = false;
    });
    builder.addCase(gerarRelatorioCreditosConsignatario.rejected, (state, action) => {
      state.loadingCreditosConsignatario = false;
    });

    //buscar relatorio lancamento financeiro
    builder.addCase(buscarRelatorioLancamentoFinanceiro.pending, (state) => {
      state.loadingLancamentoFinanceiro = true;
    });
    builder.addCase(buscarRelatorioLancamentoFinanceiro.fulfilled, (state, action) => {
      state.listLancamentoFinanceiro = action.payload;
      state.loadingLancamentoFinanceiro = false;
    });
    builder.addCase(buscarRelatorioLancamentoFinanceiro.rejected, (state, action) => {
      state.loadingLancamentoFinanceiro = false;
    });

    //buscar relatorio lancamento financeiro drill
    builder.addCase(buscarRelatorioLancamentoFinanceiroDrill.pending, (state) => {
      state.loadingLancamentoFinanceiroDrill = true;
    });
    builder.addCase(buscarRelatorioLancamentoFinanceiroDrill.fulfilled, (state, action) => {
      state.listLancamentoFinanceiroDrill = action.payload;
      state.loadingLancamentoFinanceiroDrill = false;
    });
    builder.addCase(buscarRelatorioLancamentoFinanceiroDrill.rejected, (state, action) => {
      state.loadingLancamentoFinanceiroDrill = false;
    });

    //buscar relatorio lancamento financeiro por mes
    builder.addCase(buscarRelatorioLancamentoFinanceiroPorMes.pending, (state) => {
      state.loadingLancamentoFinanceiro = true;
    });
    builder.addCase(buscarRelatorioLancamentoFinanceiroPorMes.fulfilled, (state, action) => {
      state.listLancamentoFinanceiroPorMes = action.payload;
      state.loadingLancamentoFinanceiro = false;
    });
    builder.addCase(buscarRelatorioLancamentoFinanceiroPorMes.rejected, (state, action) => {
      state.loadingLancamentoFinanceiro = false;
    });

    //buscar relatorio lancamento financeiro por mes drill
    builder.addCase(buscarRelatorioLancamentoFinanceiroPorMesDrill.pending, (state) => {
      state.loadingLancamentoFinanceiroDrill = true;
    });
    builder.addCase(buscarRelatorioLancamentoFinanceiroPorMesDrill.fulfilled, (state, action) => {
      state.listLancamentoFinanceiroDrill = action.payload;
      state.loadingLancamentoFinanceiroDrill = false;
    });
    builder.addCase(buscarRelatorioLancamentoFinanceiroPorMesDrill.rejected, (state, action) => {
      state.loadingLancamentoFinanceiroDrill = false;
    });

    //gerar relatorio consolidado saldo bancario
    builder.addCase(gerarRelatorioConsolidadoSaldoBancario.pending, (state) => {
      state.loadingConsolidadoSaldoBancario = true;
    });
    builder.addCase(gerarRelatorioConsolidadoSaldoBancario.fulfilled, (state, action) => {
      state.listConsolidadoSaldoBancario = action.payload;
      state.loadingConsolidadoSaldoBancario = false;
    });
    builder.addCase(gerarRelatorioConsolidadoSaldoBancario.rejected, (state) => {
      state.loadingConsolidadoSaldoBancario = false;
    });

    //gerar relatorio consolidado saldo bancario detalhe
    builder.addCase(gerarRelatorioConsolidadoSaldoBancarioDetalhe.pending, (state) => {
      state.loadingConsolidadoSaldoBancarioDetalhe = true;
    });
    builder.addCase(gerarRelatorioConsolidadoSaldoBancarioDetalhe.fulfilled, (state, action) => {
      state.listConsolidadoSaldoBancarioDetalhe = action.payload;
      state.loadingConsolidadoSaldoBancarioDetalhe = false;
    });
    builder.addCase(gerarRelatorioConsolidadoSaldoBancarioDetalhe.rejected, (state) => {
      state.loadingConsolidadoSaldoBancarioDetalhe = false;
    });

    //gerar relatorio consolidado saldo bancario resumo
    builder.addCase(gerarRelatorioConsolidadoSaldoBancarioResumo.pending, (state) => {
      state.loadingConsolidadoSaldoBancarioResumo = true;
    });
    builder.addCase(gerarRelatorioConsolidadoSaldoBancarioResumo.fulfilled, (state, action) => {
      state.listConsolidadoSaldoBancarioResumo = action.payload;
      state.loadingConsolidadoSaldoBancarioResumo = false;
    });
    builder.addCase(gerarRelatorioConsolidadoSaldoBancarioResumo.rejected, (state) => {
      state.loadingConsolidadoSaldoBancarioResumo = false;
    });
  },
});

export const {
  //gerar relatorio conta bancaria
  setBuscaRelatorioContaBancaria,
  //gerar relatorio creditos consignatarios
  setBuscaRelatorioCreditosConsignatario,
  //buscar relatorio lancamento financeiro
  setBuscaRelatorioLancamentoFinanceiro,
  setRelatorioLancamentoFinanceiro,
  //internal
  setModalRelatorioLancamentoFinanceiro,
  clearRelatorio,
  resetRelatorioContaBancaria,
  setBuscaConsolidadoSaldoBancario,
  resetRelatorioConsolidadoSaldoBancario,
} = relatorioSlice.actions;

export default relatorioSlice.reducer;
